import { render, staticRenderFns } from "./quesSuccess4.vue?vue&type=template&id=1ad5f0b0"
import script from "./quesSuccess4.vue?vue&type=script&lang=js"
export * from "./quesSuccess4.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess4.vue?vue&type=style&index=0&id=1ad5f0b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports